module.exports = __webpack_public_path__ + "static/media/password-input.33b2fd65.svg";